import { SearchOutlined } from '@ant-design/icons';
import { AutoComplete, Button, Input, message, Modal } from 'antd';
import 'moment/locale/sr';
import React, { useState } from 'react';
import api from '../../../utils/api';

const ProcessLogModal = ({ children, sawlist, name, onOk, ...rest }) => {
  const [visible, setVisible] = useState(false);

  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState(null);
  const [selectedLog, setSelectedLog] = useState(null);

  const addSawlist = (id, force = false) => {
    const key = 'sawlistProcess';
    setLoading(false);
    api
      .post(`sawlist/process`, {
        id,
        sawlist,
        force,
      })
      .then((response) => {
        message.success({
          content: `Trupac broj ${response.data.result.plate} uspješno dodan na listu prerade!`,
          key,
          duration: 5,
        });
        setInput('');
        onOk(false);
        setSelectedLog(null);
        setLogs(null);
        setLoading(false);
      })
      .catch((error) => {
        error.response.data.errors.forEach((error) => {
          if (error.msg === 'invalid_supplier') {
            message.error({
              content: `Greška! Ovaj trupac ne pripada dobavljaču ${name}.`,
              key,
              duration: 5,
            });
          } else {
            message.error({
              content: 'Greška pri dodavanju trupca na listu prerade.',
              key,
              duration: 5,
            });
          }
        });
        console.log(error);
        setLoading(false);
      });
  };

  const searchLogs = (plate) => {
    if (plate !== '') {
      setLoading(true);
      api
        .post(`log/search`, { plate }, { params: { group: true } })
        .then((response) => {
          setLogs(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setLogs(null);
    }
  };

  const logsArray = logs && [].concat.apply([], Object.values(logs));
  const objSelectedLog =
    logsArray &&
    selectedLog &&
    (logsArray.find((x) => x.id === selectedLog.id) ||
      logsArray.find((x) => x.plate === selectedLog.plate));

  return (
    <>
      <div onClick={() => setVisible(true)}>{children}</div>
      <Modal
        confirmLoading={loading}
        visible={visible}
        title='Dodavanje trupca na listu prerade'
        okText='Dodaj trupac'
        cancelText='Otkaži'
        okButtonProps={{
          disabled: !objSelectedLog,
        }}
        onCancel={() => setVisible(false)}
        onOk={() => {
          if (!objSelectedLog.sawlist && !objSelectedLog.processed && !objSelectedLog.trashed) {
            addSawlist(objSelectedLog.id);
          } else {
            message.error({
              content: objSelectedLog.processed ? (
                <>
                  Trupac već prerađen!
                  <Button type='link' onClick={() => addSawlist(objSelectedLog.id, true)}>
                    Ipak dodaj
                  </Button>
                </>
              ) : objSelectedLog.trashed ? (
                <>
                  Trupac vraćen sa stanja!
                  <Button type='link' onClick={() => addSawlist(objSelectedLog.id, false)}>
                    Ipak dodaj
                  </Button>
                </>
              ) : (
                `Trupac već na listi prerade!`
              ),
              duration: 5,
            });
          }
        }}>
        <AutoComplete
          style={{ width: '100%' }}
          notFoundContent='Nema trupaca sa traženom pločicom.'
          options={
            logs &&
            Object.keys(logs).map((type) => {
              return {
                label: type,
                options: logs[type].map((log) => {
                  return {
                    key: log.id,
                    label: log.plate,
                    value: log.plate,
                  };
                }),
              };
            })
          }
          value={input}
          onChange={(value) => {
            setInput(value);
            searchLogs(value);
          }}
          onSelect={(value, option) => {
            if (option) {
              setSelectedLog({ id: option.key, plate: value });
            }
          }}
          backfill
          allowClear
          filterOption={(inputValue, option) =>
            option.value && option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }>
          <Input
            style={{ width: '100%' }}
            prefix={<SearchOutlined />}
            placeholder='Pretražite trupce'
          />
        </AutoComplete>
      </Modal>
    </>
  );
};

export default ProcessLogModal;
